import { loginPath } from "../utils/urls";
import { Icon } from "designsystem/src/stories/Basic/Icon";
import { I18NParagraph } from "designsystem/src/stories/Elements/I18NParagraph";
import { I18NButton } from "designsystem/src/stories/Controls/I18NButton";

export function StartPage() {
	return <>
		<Icon icon={"fidodemo-start"} className="start-image" />
		<I18NParagraph i18n={"fidodemo.start-1"} />
		<I18NParagraph i18n={"fidodemo.start-2"} />
		<a href={loginPath} className="start-button">
			<I18NButton id="fidodemo-start-button" i18n="fidodemo.start-button" mode="yellow" />
		</a>
	</>;
}
